var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "subscription-loader-overlay" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "subscription-loader-spinner" }, [
      _c("div", { staticClass: "spinner" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }